import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import React from 'react'
import { controlHasError } from '../../lib/errorHandler'
import ExpandablePanel from '../controls/ExpandablePanel'
import KasKrs from '../KasKrs'

class IdentyfikacjaPodmiotuSkrocona extends React.Component {
  render() {
    const {
      errors,
      data,
      onSetKRS,
      onSetSectionData,
      onLoadGUS,
      onSetName,
    } = this.props
    return (
      <ExpandablePanel title="IDENTYFIKACJA PODMIOTU">
        <form
          name="IdentyfikacjaPodmiotuSkrocona"
          autoComplete="off"
          className="identyfikacjaPodmiotu"
        >
          <KasKrs
            className="kasKrs"
            hasError={name => controlHasError(errors, name)}
            data={{
              CzyKRS: data.CzyKRS,
              IdentyfikatorPodmiotu: data.IdentyfikatorPodmiotu,
            }}
            onSetSectionData={e => {
              if (e.target.name === 'CzyKRS') {
                onSetSectionData(e.target.name, e.target.value === 'true')
                onSetKRS(e.target.value === 'true')
              } else onSetSectionData(e.target.name, e.target.value)
            }}
            onLoadGUS={onLoadGUS}
          />
          <FormControl component="fieldset" className="nazwa">
            <TextField
              error={controlHasError(errors, 'NazwaFirmy')}
              name="NazwaFirmy"
              label="Nazwa pełna"
              title={data.NazwaFirmy}
              value={data.NazwaFirmy}
              onChange={e => {
                onSetSectionData(e.target.name, e.target.value)
                onSetName(e.target.value)
              }}
            />
          </FormControl>
        </form>
      </ExpandablePanel>
    )
  }
}

export default IdentyfikacjaPodmiotuSkrocona
